import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { GrFormNext } from "react-icons/gr";

const BreadCrumb3 = (props) => {
  const { title } = props;

  const productState = useSelector((state) => state?.product?.singleproduct);

  const brand = productState?.brand || " ";   
  const formattedBrand = brand.toLowerCase().split(" ").join("-");  

  const productType = useMemo(() => {
    if (!productState) return " ";
    return productState.type || " ";
  }, [productState]);

  const type = productType;
  const formattedType = type.toLowerCase().split(" ").join("-");
  const typeRoute = `/${formattedType}`;

  return (
    <div className="breadcrumb mb-0 py-4 px-3">
      <div className="container-xxl">
        <div className="row">
          <div className="col-12">
            <span className="text-align-start mb-0">
              <Link to="/" className="text-dark">
                Home&nbsp;
              </Link>
              <span>
                <GrFormNext />&nbsp;
              </span>

              <Link to={typeRoute} className="text-dark">
                {type}&nbsp;
              </Link>
              <span>
                <GrFormNext />&nbsp;
              </span>

              <Link to={`${typeRoute}/brand/${formattedBrand}`} className="text-dark">
                {brand}&nbsp;
              </Link>
              <span>
                <GrFormNext />&nbsp;
                <span className="page" aria-current="page">{title}</span>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreadCrumb3;
